import {RequestMethod} from './fetch'

type XHROptions = {
  method?: RequestMethod
  headers?: Record<string, string>
  body?: Document | XMLHttpRequestBodyInit | null
}

export const xhrRequest = (
  url: string,
  {method, headers, body}: XHROptions,
  onProgress?: (ev: ProgressEvent<EventTarget>, xhr: XMLHttpRequest) => void
): Promise<{status: number; body: string}> => {
  return new Promise((res, rej) => {
    const xhr = new window.XMLHttpRequest()
    xhr.open(method ?? 'get', url)
    Object.entries(headers ?? {}).forEach(([k, v]) => {
      xhr.setRequestHeader(k, v)
    })
    xhr.onload = () => {
      if (xhr.readyState === xhr.DONE) {
        res({status: xhr.status, body: xhr.responseText})
      }
    }
    xhr.onerror = rej
    if (xhr.upload && onProgress) {
      // p.loaded / p.total * 100 and p.lengthComputable are useful here
      xhr.upload.onprogress = p => onProgress(p, xhr)
    }
    if (body) {
      xhr.send(body)
    }
  })
}
